import * as styles from './header.module.scss';

import React, { useEffect, useState } from 'react';
import {
  faAngleDown,
  faArrowRight,
  faBolt,
  faBook,
  faBooks,
  faChartNetwork,
  faGraduationCap,
  faHandHoldingBox,
  faImages,
  faMinus,
  faPencilPaintbrush,
  faPlus,
  faShoppingCart,
  faSlidersH,
  faSparkles,
  faUserChart,
  faUsers,
} from '@fortawesome/pro-regular-svg-icons';

import Button from '../button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'gatsby';
import Logo from '../logo';

const Header = ({
  style,
  btnLabel = 'Start for free',
  btnLink,
  btnTheme = 'outline',
  btnType = 'external',
  btnIcon = true,
  hideBtn = false,
  transparent = false,
}) => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [mobileSection, setMobileSection] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 48) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header
      style={{ ...style }}
      className={[
        styles.header,
        scrolled ? styles.scrolled : '',
        transparent && !scrolled && !mobileMenu ? styles.transparent : '',
      ].join(' ')}>
      <div className="container-lg">
        <div className="row align-items-center justify-content-between">
          <div className="col-auto">
            <div className="d-flex align-items-center" style={{ gap: '24px' }}>
              <Link to="/">
                <div className={styles.logo}>
                  <Logo color="#000000" />
                </div>
              </Link>
              <nav className="d-none d-lg-flex" role="presentation">
                <ul>
                  <li role="presentation">
                    <button className={[styles.btn].join(' ')}>
                      Product <FontAwesomeIcon icon={faAngleDown} />
                    </button>
                    <div className={[styles.popover].join(' ')}>
                      <div className={styles.popoverNavGroup}>
                        <Link to="/features/" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faSlidersH} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>Features</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Explore our powerful tools that boost conversions.
                            </p>
                          </div>
                        </Link>
                        <a href="https://ai.tryinteract.com/create" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faSparkles} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>AI Quiz Maker</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Create quizzes tailored to your business with AI.
                            </p>
                          </div>
                        </a>
                        <Link to="/integrations/" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faBolt} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>Integrations</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Connect quizzes to your favorite platforms.
                            </p>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </li>
                  <li role="presentation">
                    <button className={[styles.btn].join(' ')}>
                      Industries <FontAwesomeIcon icon={faAngleDown} />
                    </button>
                    <div className={[styles.popover].join(' ')}>
                      <div className={styles.popoverNavGroup}>
                        <Link to="/coaches/" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faUserChart} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>Coaches</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Grow your coaching business with personalized quizzes.
                            </p>
                          </div>
                        </Link>
                        <Link to="/service/" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faHandHoldingBox} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>Service Providers</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Offer personalized solutions to your audience.
                            </p>
                          </div>
                        </Link>
                        <Link to="/enterprise/" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faChartNetwork} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>Enterprise</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Engage users with quizzes that drive retention and referrals.
                            </p>
                          </div>
                        </Link>
                        <Link to="/creators/" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faPencilPaintbrush} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>Creators</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Move followers to subscribers with engaging quizzes.
                            </p>
                          </div>
                        </Link>
                        <Link to="/ecommerce/" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faShoppingCart} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>E-Commerce</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Drive sales with personalized product recommendations.
                            </p>
                          </div>
                        </Link>

                        <Link to="/education/" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faGraduationCap} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>Education</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Educate, engage, and convert your audience with quizzes.
                            </p>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </li>
                  <li role="presentation">
                    <Link to="/plans/" className={styles.btn}>
                      Pricing
                    </Link>
                  </li>
                  <li role="presentation">
                    <button className={[styles.btn].join(' ')}>
                      Resources <FontAwesomeIcon icon={faAngleDown} />
                    </button>
                    <div className={[styles.popover].join(' ')}>
                      <div className={styles.popoverNavGroup}>
                        <a href="https://ai.tryinteract.com/tools" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faSparkles} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>Free AI Tools</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Try out our AI tools for quizzes, chatbots, and more.
                            </p>
                          </div>
                        </a>
                        <Link to="/quizzes/" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faImages} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>Quiz Gallery</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Explore diverse quizzes for various industries and use cases.
                            </p>
                          </div>
                        </Link>
                        <Link to="/examples/" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faBook} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>Examples</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Browse curated collection of high-performing quizzes.
                            </p>
                          </div>
                        </Link>
                        <Link to="/about/" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faUsers} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>About Us</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Learn about our mission, values, and team.
                            </p>
                          </div>
                        </Link>
                        <a href="/blog/" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faBooks} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>Blog & Articles</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Expert insights on quiz marketing & lead gen strategies.
                            </p>
                          </div>
                        </a>
                        <Link to="/plus/" className={styles.popoverBtn}>
                          <span className={styles.icon}>
                            <FontAwesomeIcon icon={faPlus} />
                          </span>
                          <div className="d-flex flex-column" style={{ gap: '4px' }}>
                            <p className="text-body color-black">
                              <strong>Interact Plus</strong>
                            </p>
                            <p className="text-body color-muted-foreground">
                              Work with a quiz expert to create your quiz funnel.
                            </p>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </li>
                  <li role="presentation">
                    <Link to="/contact/" className={styles.btn}>
                      Support
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div className="col-auto">
            <nav className="d-none d-lg-flex" role="presentation">
              <ul>
                <li role="presentation">
                  <Button
                    theme="ghost"
                    type="external"
                    href={`${process.env.GATSBY_DASHBOARD_URL}/login`}>
                    Login
                  </Button>
                </li>
                {!hideBtn && (
                  <li role="presentation">
                    <Button
                      theme={btnTheme}
                      type={btnType}
                      href={btnLink || `${process.env.GATSBY_DASHBOARD_URL}/register`}
                      style={{ gap: '8px' }}>
                      {btnLabel}
                      {btnIcon && <FontAwesomeIcon icon={faArrowRight} />}
                    </Button>
                  </li>
                )}
              </ul>
            </nav>
            <nav className="d-lg-none">
              <Button
                theme="outline"
                type="button"
                aria-label="open menu"
                className={[styles.mobileNavBtn, mobileMenu ? styles.active : ''].join(' ')}
                onClick={() => setMobileMenu(!mobileMenu)}
                tabIndex={0}>
                <span>&nbsp;</span>
              </Button>
              {mobileMenu && (
                <div id="site-header-menu" className={styles.siteHeaderMenu}>
                  <button
                    className={[styles.mobileNavLink].join(' ')}
                    onClick={() =>
                      setMobileSection(mobileSection === 'product' ? null : 'product')
                    }>
                    <span>Product</span>
                    {mobileSection !== 'product' ? (
                      <FontAwesomeIcon icon={faPlus} />
                    ) : (
                      <FontAwesomeIcon icon={faMinus} />
                    )}
                  </button>
                  {mobileSection === 'product' && (
                    <div style={{ paddingLeft: '24px' }}>
                      <Link to="/features/" className={styles.mobileNavLink}>
                        Features
                      </Link>
                      <a href="https://ai.tryinteract.com/create" className={styles.mobileNavLink}>
                        AI Quiz Maker
                      </a>
                    </div>
                  )}
                  <button
                    className={[styles.mobileNavLink].join(' ')}
                    onClick={() =>
                      setMobileSection(mobileSection === 'industries' ? null : 'industries')
                    }>
                    <span>Industries</span>
                    {mobileSection !== 'industries' ? (
                      <FontAwesomeIcon icon={faPlus} />
                    ) : (
                      <FontAwesomeIcon icon={faMinus} />
                    )}
                  </button>
                  {mobileSection === 'industries' && (
                    <div style={{ paddingLeft: '24px' }}>
                      <Link to="/coaches/" className={styles.mobileNavLink}>
                        Coaches
                      </Link>
                      <Link to="/creators/" className={styles.mobileNavLink}>
                        Creators
                      </Link>
                      <Link to="/service/" className={styles.mobileNavLink}>
                        Service Providers
                      </Link>
                      <Link to="/ecommerce/" className={styles.mobileNavLink}>
                        E-Commerce
                      </Link>
                      <Link to="/enterprise/" className={styles.mobileNavLink}>
                        Enterprise
                      </Link>
                      <Link to="/education/" className={styles.mobileNavLink}>
                        Education
                      </Link>
                    </div>
                  )}
                  <Link to="/integrations/" className={styles.mobileNavLink}>
                    Integrations
                  </Link>
                  <Link to="/plans/" className={styles.mobileNavLink}>
                    Pricing
                  </Link>
                  <button
                    className={[styles.mobileNavLink].join(' ')}
                    onClick={() =>
                      setMobileSection(mobileSection === 'resources' ? null : 'resources')
                    }>
                    <span>Resources</span>
                    {mobileSection !== 'resources' ? (
                      <FontAwesomeIcon icon={faPlus} />
                    ) : (
                      <FontAwesomeIcon icon={faMinus} />
                    )}
                  </button>
                  {mobileSection === 'resources' && (
                    <div style={{ paddingLeft: '24px' }}>
                      <a href="https://ai.tryinteract.com/tools" className={styles.mobileNavLink}>
                        Free AI Tools
                      </a>
                      <Link to="/quizzes/" className={styles.mobileNavLink}>
                        Quiz Gallery
                      </Link>
                      <Link to="/examples/" className={styles.mobileNavLink}>
                        Examples
                      </Link>
                      <Link to="/about/" className={styles.mobileNavLink}>
                        About Us
                      </Link>
                      <a href="/blog/" className={styles.mobileNavLink}>
                        Blog & Articles
                      </a>
                      <Link to="/plus/" className={styles.mobileNavLink}>
                        Interact Plus
                      </Link>
                    </div>
                  )}
                  <Link to="/contact/" className={styles.mobileNavLink}>
                    Support
                  </Link>

                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ gap: '8px' }}>
                    <Button
                      theme="outline"
                      type="external"
                      href={`${process.env.GATSBY_DASHBOARD_URL}/login`}
                      style={{ width: `100%`, justifyContent: `center`, margin: `1rem 0` }}>
                      Login
                    </Button>
                    <Button
                      theme="purple"
                      type="external"
                      href={`${process.env.GATSBY_DASHBOARD_URL}/register`}
                      style={{ width: `100%`, justifyContent: `center`, margin: `1rem 0` }}>
                      Start for free
                    </Button>
                  </div>
                </div>
              )}
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
